module.exports = __webpack_public_path__ + "img/webtoon_14.5753506.jpeg";